import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

const AutoLogout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    let timer;

    // 每次用户有活动时重置定时器
    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        logout();
        alert("您已长时间无操作，系统已自动退出登录。");
      }, 30* 60 * 1000); // 10 分钟
    };

    // 监听用户活动
    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // 初始化定时器
    resetTimer();

    // 组件卸载时清理事件监听器和定时器
    return () => {
      clearTimeout(timer);
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [logout]);

  return null; // 该组件不渲染任何 UI
};

export default AutoLogout;